// extracted by mini-css-extract-plugin
export default {"root":"FileName_root__wcxv6","dynamicNameBeginning":"FileName_dynamicNameBeginning__W305y","fixedNameEnding":"FileName_fixedNameEnding__wAF8E"};